import React, { useEffect, useRef, useState } from "react";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
import {
  // CaptureImageIcon,
  LocationIcon,
  RefreshIcon
} from "../../Assets/assets";
import { connect } from "react-redux";
import { isValidObject } from "../../Services/validators";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import {
  defaultTracksFilter,
  tracksFilterData
} from "../../Utils/Constants/Tracks";
import SearchBox from "../../Components/SearchBox/SearchBox";
import {
  dateAndTimeConverter,
  FilterSeparator,
  isFilterApplied,
  rippleEffect
} from "../../Utils/Constants/Constants";
import { setTableFilter, setTableSearchKey } from "../../Redux/table/action";
import { lastUpdatedAt } from "../../Redux/track/action";
import DateInput from "../../Components/Filters/Date";
import useMap from "../../CustomHooks/useMap";

function FieldView(props) {
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);
  const [mapContainerRendered, setMapContainerRendered] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [selectedFilters, setSelectedFilters] = useState(defaultTracksFilter);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const mapContainer = useRef(null);
  const [isFirstTime, setIsFirstTime] = useState(false);

  const [drawRoutesInMap, clearRoutes] = useMap({
    locations: props.locations?.data ? Object.values(props.locations.data) : [],
    container: mapContainer,
    mapContainerRendered: mapContainerRendered,
    isAuth: props.isAuth,
    theme: props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light",
    markerOnclick: (objectId) => {
      console("objectId", objectId);
    }
  });

  useEffect(() => {
    setMapContainerRendered(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      isFirstTime === false &&
      props.table.tracks.filter.date !== null &&
      isValidObject(props.tracks.data) &&
      props.claims?.beta
    ) {
      drawRoutesInMap(props.tracks.data, props.workforce.data);
      setIsFirstTime(true);
    }

    if (!isValidObject(props.tracks.data)) {
      clearRoutes();
    }

    // eslint-disable-next-line
  }, [props.tracks.data]);

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  const handleApplyClick = () => {
    setIsFirstTime(false);
    props.setTableFilter("TRACKS", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultTracksFilter[key]
    });
    props.setTableFilter("TRACKS", {
      ...props.table.tracks.filter,
      [key]: defaultTracksFilter[key]
    });
  };

  const handleClearClick = () => {
    clearRoutes();
    props.setTableFilter("TRACKS", defaultTracksFilter);
    props.setTableSearchKey("TRACKS", "");
    setSelectedFilters(defaultTracksFilter);
  };

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.tracks.filter);
    }
  }, [props.table.tracks.filter, isResetSingleKey]);

  return (
    <>
      <div className="inherit-parent-height inherit-parent-width position-relative overflow-hidden">
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            {/* <div className="display-flex">
              <div>
                <Button
                  variant="transparent"
                  text="Capture visible map"
                  icon={<CaptureImageIcon />}
                  onClick={() => {
                    if (!props.complaintsLoading.export) {
                      props.getComplaintSummary();
                    }
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
            </div> */}
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center margin-bottom-larger"
            >
              <div style={{ width: "200px" }}>
                <SearchBox
                  title="SEARCH TRACKS"
                  placeHolder="SEARCH TRACKS"
                  value={searchKey}
                  onChange={(event) => {
                    if (event.target.value.length > 0) {
                      setSearchKey(event.target.value);
                    } else {
                      setSearchKey("");
                      props.setTableSearchKey("TRACKS", "");
                    }
                  }}
                  showEnterIcon={
                    searchKey.length === 8 &&
                    props.table.tracks.searchKey !== searchKey
                      ? true
                      : false
                  }
                  enterOnClick={() => {
                    if (searchKey.length > 0) {
                      props.setTableSearchKey("TRACKS", searchKey);
                    }
                  }}
                  showCloseIcon={
                    searchKey.length > 0 &&
                    props.table.tracks.searchKey === searchKey
                      ? true
                      : false
                  }
                  closeOnClick={() => {
                    setSearchKey("");
                    props.setTableSearchKey("TRACKS", "");
                  }}
                />
              </div>
              <div className="display-flex flex-align-items-center position-relative">
                <FilterSeparator />

                <DateInput
                  disabled={handleDisableFilter()}
                  loading={props.tracks.loading}
                  data-cy="DATE"
                  multiple={false}
                  data={tracksFilterData()[0]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  isFilterApplied={
                    props.table.tracks?.filter?.date !==
                    new Date().toISOString().split("T")[0]
                  }
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.tracks.filter}
                  selected={selectedFilters["date"]}
                />
              </div>
            </div>

            {(isFilterApplied(selectedFilters, "TRACKS").validation ||
              isFilterApplied(props.table.tracks.filter, "TRACKS")
                .validation) && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.tracks.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleClearClick();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            height: `calc(100% - ${height}px)`
          }}
        >
          <div className="inherit-parent-height inherit-parent-width">
            <div
              ref={mapContainer}
              className={`inherit-parent-height inherit-parent-width overflow-hidden`}
              data-cy="MAP-CONTAINER"
            />
          </div>
        </div>

        {!isValidObject(props.tracks.data) && props.claims?.beta && (
          <div
            style={{
              position: "absolute",
              top: "130px"
            }}
            className="height-fit-content width-fit-content position-absolute z-index-1 bottom-32px left-32px"
          >
            <InfoCard
              loading={props.tracks.loading}
              theme={props.theme}
              title="NO INFO ON APPLIED DATE"
            />
          </div>
        )}

        {isValidObject(props.tracks.data) && props.claims?.beta && (
          <div
            style={{
              position: "absolute",
              top: "130px"
            }}
            className="height-fit-content width-fit-content position-absolute z-index-1 bottom-32px left-32px"
          >
            <RefreshCard
              theme={props.theme}
              loading={props.tracks.loading || props.tracks.trackerLoading}
              title={
                props.tracks.lastUpdatedAt
                  ? `Last Updated - ${dateAndTimeConverter(
                      props.tracks.lastUpdatedAt,
                      "Time"
                    )}, ${dateAndTimeConverter(
                      props.tracks.lastUpdatedAt,
                      "cardDate"
                    )}`
                  : "Refresh"
              }
              refreshOnClick={(e) => {
                rippleEffect(e);
                props.lastUpdatedAt();
                drawRoutesInMap(props.tracks.data, props.workforce.data);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    auth: state.auth,
    locations: state.locations,
    tracks: state.tracks,
    table: state.table,
    workforce: state.workforce
  };
};

const mapDispatchToProps = function() {
  return {
    setTableSearchKey: (tableName, data) => setTableSearchKey(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    lastUpdatedAt: () => lastUpdatedAt()
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FieldView);

function InfoCard(props) {
  return (
    <div
      data-cy="LOCATION-TRACKER-INFO-CARD"
      style={{
        width: "260px",
        height: "48px",
        border: "solid 1px var(--tertiaryColor)"
      }}
      className="display-flex background-color-tertiaryColor1 flex-justify-content-center info-card-box-shadow font-color-tertiaryColor flex-direction-column flex-align-items-center  font-size-default border-radius-32px"
    >
      <div className="display-flex flex-align-items-center flex-justify-content-center">
        {props.loading ? (
          <div
            style={{
              height: "16px",
              width: "16px"
            }}
          >
            <div className="qr-loader" />
          </div>
        ) : (
          <div
            style={{
              height: "20px",
              width: "20px"
            }}
          >
            <LocationIcon
              height="22"
              width="22"
              color="var(--tertiaryColor6)"
            />
          </div>
        )}

        <div className="font-size-small padding-left-large">
          {props.loading ? "Fetching Latest Data..." : props.title}
        </div>
      </div>
    </div>
  );
}

function RefreshCard(props) {
  return (
    <div
      onClick={props.refreshOnClick}
      data-cy="LOCATION-TRACKER-REFRESH-CARD"
      style={{
        width: "260px",
        height: "48px",
        border: "solid 1px var(--tertiaryColor)"
      }}
      className="display-flex background-color-tertiaryColor1 flex-justify-content-center cursor-pointer ripple-element info-card-box-shadow font-color-tertiaryColor flex-direction-column flex-align-items-center font-size-default  border-radius-32px"
    >
      <div className="display-flex flex-align-items-center flex-justify-content-center">
        {props.loading ? (
          <div
            className="display-flex flex-justify-content-center flex-align-items-center"
            style={{
              height: "14px",
              width: "14px"
            }}
          >
            <div className="qr-loader" />
          </div>
        ) : (
          <div
            style={{
              height: "14px",
              width: "14px"
            }}
          >
            <RefreshIcon height="16" width="15" color="var(--tertiaryColor6)" />
          </div>
        )}

        <div className="font-size-small padding-top-smaller padding-left-large white-space-nowrap">
          {props.loading ? "Fetching Latest Data..." : props.title}
        </div>
      </div>
    </div>
  );
}
